import React from 'react';
import { promoDateLabel } from '../../../utils/promoDates';
import { WHEEL_SECTORS, SECTOR_ANGLE, SPIN_DURATION_MS } from '../../../utils/promoWheel';

function ChaosStar({ className = '' }) {
  return <svg className={className} viewBox='0 0 100 100' fill='currentColor' aria-hidden='true' focusable='false'>
    {Array.from({ length: 8 }, (_, index) => <path key={index} transform={`rotate(${index * 45} 50 50)`}
      d='M47 50V21H40L50 4L60 21H53V50Z' />)}
    <circle cx='50' cy='50' r='9' />
  </svg>;
}

export default function PromoWheelOffer({ campaign, spinning, rotation, onSpin }) {
  return <article className='promo-wheel-offer'>
    <ChaosStar className='promo-wheel-background-star' />
    <div className='promo-wheel-copy'>
      <span className='promo-wheel-eyebrow'><span aria-hidden='true'>🎃</span> Halloween · {campaign.title}</span>
      <h4>Випробуйте волю<br />Богів Хаосу!</h4>
      <p className='promo-wheel-intro'>Один оберт — і ваша доля вирішена. Отримайте персональний промокод на наступне замовлення.</p>
      <p className='promo-wheel-guarantee'><i className='bi bi-gift' aria-hidden='true' />Гарантована знижка <strong>від 3% до 5%</strong></p>
      <button type='button' className='btn btn-dark promo-wheel-spin-button' disabled={spinning} onClick={onSpin}>
        {spinning ? 'Хаос вирішує…' : 'Крутити Колесо Хаосу'}
      </button>
      <p className='promo-wheel-deadline'>Одна спроба на акаунт · Діє до {promoDateLabel(campaign.expiresAt)}</p>
      <details className='promo-wheel-terms'>
        <summary>Умови акції</summary>
        <div>
          <p>Промокод діє на одне замовлення лише у вашому акаунті, зокрема на акційні товари. Знижка за кодом застосовується до ціни після персональної або акційної знижки: наприклад, 10% та додаткові 5% разом зменшують початкову ціну на 14,5%.</p>
        </div>
      </details>
    </div>
    <div className='promo-wheel-stage' aria-label='Колесо знижок: 3%, 4%, 5%' aria-busy={spinning}>
      <div className='promo-wheel-pointer' />
      <div className='promo-wheel-disc' style={{ transform: `rotate(${rotation}deg)`, '--spin-duration': `${SPIN_DURATION_MS}ms` }} aria-hidden='true'>
        {WHEEL_SECTORS.map((prize, index) => <span key={index} className={`promo-wheel-segment promo-wheel-segment--${prize}`}
          style={{ '--segment-angle': `${index * SECTOR_ANGLE}deg` }}>{prize}%</span>)}
      </div>
      <div className='promo-wheel-hub' aria-hidden='true'><ChaosStar /><span>ХАОС</span></div>
    </div>
  </article>;
}
